import React, { ReactNode } from "react";
import StepperNavigation from "./components/StepperNavigation";

interface StepperProps {
  children: ReactNode[];
  activeStepIndex: number;
}

const Stepper = ({ children, activeStepIndex }: StepperProps) => {
  const renderContent = () => {
    if (children && children.length > 0) {
      return React.Children.map(children, (child, index) => (index === activeStepIndex ? child : null));
    }
    return null;
  };

  return (
    <div data-testid="stepper">
      <StepperNavigation activeStepIndex={activeStepIndex} children={children} />
      <div>{renderContent()}</div>
    </div>
  );
};

export default Stepper;
